if (process.env.NODE_ENV === 'production') {
  ;(() => {
    const w = window as any

    // If already initialized or window is undefined, return early
    if (!w || w.bpx) return

    // Create a queueing function with process handling like the original
    w.bpx = (...args: any[]) => {
      if (!args?.length) return
      if (w.bpx.process) {
        w.bpx.process.apply(w.bpx, args)
      } else {
        w.bpx.queue = w.bpx.queue || []
        w.bpx.queue.push(args)
      }
    }

    // Initialize queue and timestamp
    w.bpx.queue = []
    w.bpx.t = +new Date()

    // Create and inject script
    const s = document.createElement('script')
    s.async = true
    s.src = `https://static.bilinmedia.net/pixel/bpx.min.js?t=${
      864e5 * Math.ceil(Date.now() / 864e5)
    }`

    // Use insertBefore instead of appendChild
    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(s, firstScript)
  })()

  // Ensure window is defined before making calls
  if (typeof window !== 'undefined') {
    const { bpx } = window as any
    bpx?.('init', '856')
    bpx?.('event', 'pageload')
  }
}
